
/**
 * @export
 * @enum {string}
 */
export enum LimitPeriod {
    MINUTE = 'MINUTE',
    HOUR = 'HOUR',
    DAY = 'DAY',
    MONTH = 'MONTH'
}